import { httpGet, httpPost } from './request'

export const queryProject = (data?: any) => {
  return httpGet({
    url: '/ikg/file/queryProject',
    data,
  })
}

export const exportProject = (data: any) => {
  return httpPost({
    url: '/ikg/file/projectExport',
    data,
    responseType: 'blob',
  })
}

export const queryProjectDetail = (data: any) => {
  return httpGet({
    url: '/ikg/file/queryProjectDetail',
    data,
  })
}

export const inputExcel = (data: any) => {
  return httpPost({
    url: '/ikg/dict/item/inputExcel',
    data,
    responseType: 'blob',
  })
}

export const dictImport = (data: any) => {
  return httpPost({
    url: '/ikg/dict/item/import',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  })
}
